import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Form, Input, Button, Alert, Checkbox, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useUser } from '../../context/UserContext';
import userService from '../../services/userService';
import { APP_CONFIG } from '../../config';

// Removed unused Typography components

const Login = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useUser();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      setError('');
      
      const { email, password } = values;
      
      // Call login API
      const response = await userService.login({
        email,
        password
      });
      
      const { data } = response;
      
      if (data && data.status) {
        // Store token in localStorage (similar to Vue cookie)
        const token = data.token;
        const user = data.user;
        
        // Prepare user data for context
        const userData = {
          name: user.firstname,
          avatar: '@AVATAR',
          address: 'Mumbai',
          welcome: 'Welcome',
          timefix: `Date: ${new Date().toLocaleDateString('en-GB')}`,
          ...user
        };
        
        // Login user through context
        await login({
          token,
          user: userData
        });
        
        // Show success message
        message.success('User successfully logged in', 3);
        
        // Navigate to dashboard
        navigate('/dashboard/dashboard');
        
      } else {
        setError('Please enter valid email and password');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Please enter valid email and password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="a-container" style={{ 
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      overflow: 'auto',
      background: '#f0f2f5 no-repeat center 110px',
      backgroundSize: '100%'
    }}>
      <div className="content" style={{ 
        padding: '32px 0',
        flex: 1
      }}>
        <div className="login" style={{ 
          width: '440px',
          margin: '0 auto',
          '@media screen and (max-width: 576px)': {
            width: '95%'
          }
        }}>
          <Card>
            <div className="top" style={{ textAlign: 'center' }}>
              <img 
                alt="logo" 
                className="logo" 
                src={APP_CONFIG.systemLogoDark}
                style={{ 
                  height: '70px',
                  verticalAlign: 'top',
                  marginRight: '16px'
                }}
              />
              <br />
              <br />
              <div className="desc" style={{ 
                fontSize: '14px',
                color: 'rgba(0, 0, 0, 0.45)',
                marginTop: '12px',
                marginBottom: '40px'
              }}>
                Welcome to {APP_CONFIG.systemName} Admin
              </div>
            </div>

            <Form
              form={form}
              name="login"
              onFinish={onFinish}
              layout="vertical"
              size="large"
              initialValues={{
                remember: true
              }}
            >
              {error && (
                <Alert
                  type="error"
                  closable
                  message={error}
                  showIcon
                  style={{ marginBottom: '24px' }}
                  onClose={() => setError('')}
                />
              )}
              
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: 'Please input your email!' },
                  { type: 'email', message: 'Please enter a valid email!' }
                ]}
              >
                <Input 
                  prefix={<UserOutlined />} 
                  placeholder="Enter email"
                  style={{ width: '90%' }}
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{ required: true, message: 'Please input your Password!' }]}
              >
                <Input.Password 
                  prefix={<LockOutlined />} 
                  placeholder="Enter password"
                  style={{ width: '90%' }}
                />
              </Form.Item>

              <Form.Item
                name="remember"
                valuePropName="checked"
              >
                <Checkbox>Remember me</Checkbox>
              </Form.Item>

              <Form.Item>
                <Button
                  loading={loading}
                  type="primary"
                  htmlType="submit"
                  block
                  style={{ 
                    width: '100%',
                    marginTop: '24px',
                    height: '48px',
                    fontSize: '16px'
                  }}
                >
                  Login
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </div>
      
      {/* Footer - similar to GlobalFooter */}
      <div style={{ 
        textAlign: 'center',
        padding: '24px',
        color: 'rgba(0, 0, 0, 0.45)',
        fontSize: '14px'
      }}>
        <p style={{ margin: 0 }}>
          {APP_CONFIG.copyright} © {new Date().getFullYear()}
        </p>
        <div style={{ marginTop: '8px' }}>
          {APP_CONFIG.footerLinks.map((link, index) => (
            <a 
              key={index}
              href={link.link} 
              style={{ 
                color: 'rgba(0, 0, 0, 0.45)',
                textDecoration: 'none',
                margin: '0 8px'
              }}
            >
              {link.name}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Login;
